
export class UserEntityTypes {
    static readonly LABEL_GUEST = 'guest';
    static readonly LABEL_B2C = 'B2C';
    static readonly LABEL_B2B = 'B2B';
    static readonly LABEL_B2B_SUB = 'B2B_SUB_USER';
    static readonly LABEL_B2B_MASTER = 'B2B_MASTER_USER';
}
